import PositionedOverlayAnchor from './PositionedOverlayAnchor';
export default PositionedOverlayAnchor;